import React from "react";
import { formatDate } from "./constants";

const AppointmentFooter = ({ createBy, createDate, updateBy, updateDate }) => {
  return (
    <div className="card-subtle-footer-stacked mt-2">
      <div className="d-flex justify-content-between align-items-center">
        <span>ผู้บันทึก: {createBy || "-"}</span>
        <span>สร้างเมื่อ: {formatDate(createDate)}</span>
      </div>
      {(updateDate || updateBy) && (
        <div className="d-flex justify-content-between align-items-center">
          <span>ผู้อัปเดต: {updateBy || "-"}</span>
          <span>อัปเดต: {formatDate(updateDate)}</span>
        </div>
      )}
    </div>
  );
};

export default AppointmentFooter;
